
export const ROUTE_PATHS = {
  Home: "/",
  Alerts: "/alerts",
  GeneralSetting: "/general-setting",
  ApiManagement: "/api-management",
  UserRoles: "/user-roles",
  UserRolesCreate: "/user-roles/create",
  UserRolesEdit: "/user-roles/edit/:id",
  Users: "/users",
  UserCreate: "/user/create",
  UserEdit: "/user/edit/:id",
  Audits: "/audits",
  Reports: "/reports",
  SystemConfig: "/system-config",
  TerminalManagement: "/device-management",
  TerminalDetail: "/device-management/terminal-detail/:id",
  LocationDetail: "/device-management/location-detail/:parentId/:id",
  UISetting: "/system-config/ui-setting",
  HostConfig: "/host-config",
  HostConfigCreate: "/host-config/create",
  HostConfigEdit: "/host-config/edit/:id",
  SignIn: "/sign-in",
  MyAccount: "/my-account",
  ChangePasscode: "/change-passcode",
  SessionTimedOut: "/session-timed-out",
  ClientNotFound: `/404`,
  NotFound: "*",
};
